import { render, staticRenderFns } from "./Realnameauthentication.vue?vue&type=template&id=af4ff1c4&scoped=true"
import script from "./Realnameauthentication.vue?vue&type=script&lang=js"
export * from "./Realnameauthentication.vue?vue&type=script&lang=js"
import style0 from "./Realnameauthentication.vue?vue&type=style&index=0&id=af4ff1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4ff1c4",
  null
  
)

export default component.exports